export default __webpack_public_path__ + "static/media/workcafe-dashboard-2.046b2df9.JPG";